<template>
	<div :class="columnClass" class="is-flex is-flex-direction-column">
		<button class="add-card" @click="$emit('click')">
			<span class="icon is-large">
				<i class="fas fa-plus"></i>
			</span>
			<span>Add new</span>
		</button>
	</div>
</template>

<script>
export default {
	name: 'AddCard',
	props: {
		columnClass: { type: String, default: 'column is-6' },
	},
	emits: ['click'],
};
</script>

<style scoped>
.add-card {
	width: 100%;
	flex: 1;
	min-height: 160px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 10px;
	border: 2px dashed #48c78e;
	background-color: transparent;
	color: #48c78e;
	cursor: pointer;
	font-weight: bold;
}
.add-card:hover {
	background-color: rgba(72, 199, 142, 0.1);
}
.add-card .icon {
	font-size: 1.8rem;
}
</style>
